import type { Element, Placement, Asset } from '../design-schema/index';
export function toPreview(x: number, y: number, p: Placement['template']) {
  return { x: p.left + x * p.areaWidth, y: p.top + y * p.areaHeight };
}
export function fromPreview(x: number, y: number, p: Placement['template']) {
  return { x: (x - p.left) / p.areaWidth, y: (y - p.top) / p.areaHeight };
}
/** x/y are centre anchors; rotation takes place in physical, not normalized units. */
export function bounds(e: Element, p: Placement) {
  const radians = e.rotation * Math.PI / 180;
  const w = e.width * p.widthInches, h = e.height * p.heightInches;
  const rw = Math.abs(w * Math.cos(radians)) + Math.abs(h * Math.sin(radians));
  const rh = Math.abs(w * Math.sin(radians)) + Math.abs(h * Math.cos(radians));
  return { left: e.x - rw / p.widthInches / 2, right: e.x + rw / p.widthInches / 2,
    top: e.y - rh / p.heightInches / 2, bottom: e.y + rh / p.heightInches / 2 };
}
export function preflight(elements: Element[], p: Placement, assets: Record<string, Asset>) {
  const errors: string[] = [], warnings: string[] = [];
  for (const e of elements.filter(e => e.visible)) {
    const b = bounds(e, p);
    if (b.left < -0.00001 || b.top < -0.00001 || b.right > 1.00001 || b.bottom > 1.00001) errors.push('Artwork extends outside the print area. Move it inward or reduce its size.');
    else if (b.left < p.safeMargin || b.top < p.safeMargin || b.right > 1-p.safeMargin || b.bottom > 1-p.safeMargin) warnings.push('Artwork is close to the print edge. Keep important details inside the dashed safe area.');
    if (e.type === 'image') {
      const asset = assets[e.assetId];
      if (!asset) errors.push('An uploaded image is missing. Upload it again.');
      else if (!asset.vector) {
        const dpi = effectiveDpi(e, p, asset);
        if (dpi < p.dpi) errors.push(`Image resolution is ${Math.floor(dpi)} DPI; this placement requires ${p.dpi} DPI. Reduce the image size or upload a larger original.`);
      }
    }
  }
  return { errors: [...new Set(errors)], warnings: [...new Set(warnings)] };
}
export function effectiveDpi(e: Element, p: Placement, a: Asset) {
  return Math.min(a.width / (e.width*p.widthInches), a.height / (e.height*p.heightInches));
}
export function snap(value: number, targets = [0.5], tolerance = 0.015) {
  return targets.find(t => Math.abs(value-t) < tolerance) ?? value;
}
export function placementPosition(p: Placement) { return { width: p.widthInches, height: p.heightInches, left: 0, top: 0 }; }
